import { createContext, useContext } from 'react';

const StoreContext = createContext();

/**
 * Provider for the PWA store context
 *
 * use the useStore hook to access it inside
 *  of components consuming this context
 */
export const Provider = StoreContext.Provider;

/**
 * retrieves the store from the store context
 * @returns the store
 */
export function useStore() {
  return useContext(StoreContext);
}
